<template>
  <div class="mb-8">
    <div class="gridClass flex flex-col justify-between text-center" :class="classes">
      <div v-if="details.title || details.desc" class="flex flex-col mb-5">
        <component :is="tag" class="font-bold text-blue-700 mb-6 text-xl lg:text-2xl">
          {{ details.title }}
        </component>
        <div class="desktop-only text-center text-sm lg:text-lg">
          {{ details.desc }}
        </div>
      </div>
      <NuxtImg 
        v-if="details.img"
        width="500"
        class="w-full mt-5 mx-4"
        loading="lazy"
        :src="details.img"
        :alt="details.alt"
      />
      <SectionVideo v-else-if="details.videoImg" :item="details.videoImg" class="mt-8" :alt="details.alt" />
      <div v-if="details.desc" class="mobile-only text-center text-lg mt-6">
        {{ details.desc }}
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  details: Object,
  classes: String,
  tag: {
    type: String,
    default: "div",
  },
})
</script>
